import { ConfigFilterItem, ConfigItem } from 'Core/interfaces'

export enum MainSearchFields {
	manifestDocument = 'manifestDocumentNumbers',
	disposalFacility = 'disposalFacilityNames'
}

export enum FilterFields {
	pickupDateFrom = 'pickupDateFrom',
	pickupDateTo = 'pickupDateTo',
	serviceSite = 'serviceSite'
}

export declare namespace BiohazardousManifest {
	interface Basic {
		biohazardousManifestDocumentId: number
		disposalFacility: Entity
		id: number
		manifestDocumentNumber: BasicString
		pickupDate: string
		serviceSite: Entity
	}

	namespace Search {
		interface Config {
			[MainSearchFields.disposalFacility]: ConfigItem<
				MainSearchFields,
				Result[MainSearchFields.disposalFacility][number]
			>
			[MainSearchFields.manifestDocument]: ConfigItem<
				MainSearchFields,
				Result[MainSearchFields.manifestDocument][number]
			>
		}

		interface Result {
			[MainSearchFields.disposalFacility]: {
				disposalFacilityName: string
				documentNumber: string
				manifestId: number
			}[]
			[MainSearchFields.manifestDocument]: {
				documentNumber: string
				manifestId: number
				disposalFacilityName: string
			}[]
		}
	}

	namespace Filter {
		interface Config {
			[FilterFields.pickupDateFrom]: ConfigFilterItem<string, null>
			[FilterFields.pickupDateTo]: ConfigFilterItem<string, null>
			[FilterFields.serviceSite]: ConfigFilterItem<string, string>
		}
	}
}
